import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { TravelBooking } from '../queries';
import { useHoldCountdown } from '../holdCountdown';

export function HoldRetentionNotice({ booking }: { booking: TravelBooking }) {
  const { t } = useTranslation();
  const countdown = useHoldCountdown(booking.state === 'held' ? booking.expiresAt : undefined);
  if (booking.state !== 'held') return null;
  return (
    <>
      <Alert severity="info">
        {t(`travelServices.booking.holdRetention.${booking.holdRetention ?? 'unknown'}`)}
      </Alert>
      {countdown.status === 'expired' && (
        <Alert severity="warning">{t('travelServices.booking.holdRateExpired')}</Alert>
      )}
    </>
  );
}
